import { render, staticRenderFns } from "./SampleTypeSingle.vue?vue&type=template&id=4203abf6"
import script from "./SampleTypeSingle.vue?vue&type=script&lang=js"
export * from "./SampleTypeSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports